/* THIS FILE IS GENERATED ON RUNTIME. DO NOT EDIT */

import { ComponentClassNameFactory } from 'lib/contexts/ComponentClassNameFactory';
import getPropStylesFactory from 'lib/utils/getPropStylesFactory';
import getComponentStylesFactory from 'lib/utils/getComponentStylesFactory';
import getComponentThemeFactory from 'lib/utils/getComponentThemeFactory';
import make_styler from '../index';

export const styles = {
  "headline_variant_default": "[&_a]:no-underline [&_a]:hover:underline",
  "headline_size_default": "text-al-headline-sm mb-0 sm:mb-0 mt-0 sm:mt-0",
  "headline_colors_primary": "",
  "images_variant_default": "",
  "images_size_default": "",
  "images_colors_primary": "",
  "body_variant_default": "",
  "body_size_default": "prose-factbox sm:prose-factbox",
  "body_colors_default": "",
  "variant_default": "",
  "size_default": "p-3 sm:p-6 my-6 rounded",
  "colors_primary": ""
};

const c = make_styler(styles);

export const propClassName = getPropStylesFactory(c, styles, "Factbox");

export const componentClassName = getComponentStylesFactory(propClassName);

export const componentTheme = getComponentThemeFactory(styles);

export const {
  ClassNameContext,
  ClassNameProvider,
  useClassName,
  useTheme,
} = ComponentClassNameFactory(componentClassName, styles);
  
export default c;